import React, {Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState} from 'react';

import {SelectInterface} from '@veneer/core';

import {ProductSku} from '@br/idm-api';

import SelectMultipleFilter from './SelectMultipleFilter';

const ProductSkuFilter = <K extends string, F extends Partial<Record<K, string[]>>>({
    field,
    label,
    filters,
    setFilters,
    getProductSkus,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
    getProductSkus: () => Promise<ProductSku[]>;
}): JSX.Element => {
    const [{productSkus, loading}, setState] = useState<{
        loading: boolean;
        productSkus: ProductSku[];
    }>({
        loading: true,
        productSkus: [],
    });
    const [productSkuFilter, setProductSkuFilter] = useState('');

    const filteredProducts = useMemo(() => {
        const filter = productSkuFilter.toLocaleLowerCase();
        return productSkus
            .filter(product => product.name.toLocaleLowerCase().includes(filter))
            .map(product => ({value: product.sku, label: product.name}));
    }, [productSkus, productSkuFilter]);

    useEffect(() => {
        void getProductSkus().then(allProducts => setState({productSkus: allProducts, loading: false}));
    }, [getProductSkus]);

    const handleSearch = useCallback<Required<SelectInterface>['onSearch']>(
        query => setProductSkuFilter(query || ''),
        []
    );
    return (
        <SelectMultipleFilter
            data-testid="product-sku-filter"
            label={label}
            field={field}
            showSearch
            filters={filters}
            setFilters={setFilters}
            options={filteredProducts}
            onSearch={handleSearch}
            disabled={loading}
        />
    );
};

export default ProductSkuFilter;
